import useVaults from '@/application/read/vaults/useVaults';
import Search from './Search';

const SearchContainer = () => {
  const { data: vaults } = useVaults();
  // const tokens: any = [
  //   {
  //     id: '0x0',
  //     name: 'Pudgy Penguins',
  //     vaultId: '0',
  //     symbol: 'PUDGY',
  //     price: 3744444473284784234n,
  //   },
  // ];
  // const collections: any = [
  //   {
  //     id: '0x0',
  //     name: 'Pudgy Penguins',
  //     imageUrl:
  //       'https://i.seadn.io/gae/yNi-XdGxsgQCPpqSio4o31ygAV6wURdIdInWRcFIl46UjUQ1eV7BEndGe8L661OoG-clRi7EgInLX4LPu9Jfw4fq0bnVYHqg7RFi?auto=format&dpr=1&w=100&h=100',
  //   },
  // ];

  return <Search vaults={vaults} />;
};

export default SearchContainer;
